import { useState } from "react";
import { Plus, Loader2 } from "lucide-react";
import axios from "axios";
import { TaskListRow } from "./TaskListRow";
import { API } from "./constants";

export const ProjectTasks = ({ projectId, tasks, stages, teamMembers, onStatusChange, onUpdateFields, onRefresh }) => {
  const [newTaskTitle, setNewTaskTitle] = useState("");
  const [newTaskStage, setNewTaskStage] = useState("");
  const [adding, setAdding] = useState(false);

  const addTask = async () => {
    if (!newTaskTitle.trim() || adding) return;
    setAdding(true);
    try {
      await axios.post(`${API}/projects/${projectId}/tasks`, {
        title: newTaskTitle.trim(),
        stage: newTaskStage || (stages?.[0]?.name || "General"),
      }, { withCredentials: true });
      setNewTaskTitle("");
      setNewTaskStage("");
      onRefresh();
    } catch (e) { console.error(e); }
    finally { setAdding(false); }
  };

  return (
    <div className="p-6 space-y-3" data-testid="tasks-tab">
      <div className="flex items-center gap-2 bg-white border border-border/50 rounded-xl px-4 py-2.5">
        <Plus className="w-4 h-4 text-foreground/45" />
        <input value={newTaskTitle} onChange={e => setNewTaskTitle(e.target.value)}
          placeholder="Add a task..."
          className="flex-1 text-sm outline-none bg-transparent placeholder:text-foreground/45"
          onKeyDown={e => e.key === "Enter" && addTask()}
          data-testid="new-task-input" />
        {stages.length > 0 && (
          <select value={newTaskStage} onChange={e => setNewTaskStage(e.target.value)} className="text-[10px] border border-border/40 rounded-lg px-2 py-1 outline-none text-foreground/50" data-testid="task-stage-select">
            <option value="">Stage...</option>
            {stages?.map(s => <option key={s.name} value={s.name}>{s.name}</option>)}
          </select>
        )}
        <button onClick={addTask} disabled={!newTaskTitle.trim() || adding} className="text-xs font-semibold px-3 py-1.5 rounded-lg bg-[#014d7d] text-white disabled:opacity-30" data-testid="add-task-btn">
          {adding ? <Loader2 className="w-3 h-3 animate-spin" /> : "Add"}
        </button>
      </div>
      {tasks?.map(t => (
        <TaskListRow key={t.id} task={t} stages={stages} teamMembers={teamMembers} onStatusChange={onStatusChange} onUpdate={onUpdateFields} />
      ))}
      {tasks.length === 0 && <p className="text-center text-foreground/45 py-8 text-sm">No tasks yet. Add one above or set up a workflow to auto-generate.</p>}
    </div>
  );
};
